import { ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Section } from '../../../screen/section';
import { VehicleSingleView } from './vehicle-single-view/vehicle-single-view';

interface Props {
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export const OfertaHeaderSection = (props: Props) => {
	const { paddingTop, paddingBottom } = props;
	return (
		<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
			<Text bold appearance={TokenTextAppearance.headline300}>
				Así que le has echado el ojo a un Volkswagen
			</Text>
			<VehicleSingleView />
		</Section>
	);
};
